import frame1 from '../../images/jpg/carousel/1.jpg'
import frame1webp from '../../images/webp/carousel/1.webp'
import frame2 from '../../images/jpg/carousel/2.jpg'
import frame2webp from '../../images/webp/carousel/2.webp'
import frame3 from '../../images/jpg/carousel/3.jpg'
import frame3webp from '../../images/webp/carousel/3.webp'
import frame4 from '../../images/jpg/carousel/4.jpg'
import frame4webp from '../../images/webp/carousel/4.webp'
import frame5 from '../../images/jpg/carousel/5.jpg'
import frame5webp from '../../images/webp/carousel/5.webp'
import frame6 from '../../images/jpg/carousel/6.jpg'
import frame6webp from '../../images/webp/carousel/6.webp'
import frame7 from '../../images/jpg/carousel/7.jpg'
import frame7webp from '../../images/webp/carousel/7.webp'
import frame8 from '../../images/jpg/carousel/8.jpg'
import frame8webp from '../../images/webp/carousel/8.webp'
import frame9 from '../../images/jpg/carousel/9.jpg'
import frame9webp from '../../images/webp/carousel/9.webp'
import frame10 from '../../images/jpg/carousel/10.jpg'
import frame10webp from '../../images/webp/carousel/10.webp'

export const imagesData = [
  {
    path: frame1,
    webpPath: frame1webp,
    bgImage: 'img/preview/carousel/1.png'
  },
  {
    path: frame2,
    webpPath: frame2webp,
    bgImage: 'img/preview/carousel/2.png'
  },
  {
    path: frame3,
    webpPath: frame3webp,
    bgImage: 'img/preview/carousel/3.png'
  },
  {
    path: frame4,
    webpPath: frame4webp,
    bgImage: 'img/preview/carousel/4.png'
  },
  {
    path: frame5,
    webpPath: frame5webp,
    bgImage: 'img/preview/carousel/5.png'
  },
  {
    path: frame6,
    webpPath: frame6webp,
    bgImage: 'img/preview/carousel/6.png'
  },
  {
    path: frame7,
    webpPath: frame7webp,
    bgImage: 'img/preview/carousel/7.png'
  },
  {
    path: frame8,
    webpPath: frame8webp,
    bgImage: 'img/preview/carousel/8.png'
  },
  {
    path: frame9,
    webpPath: frame9webp,
    bgImage: 'img/preview/carousel/9.png'
  },
  {
    path: frame10,
    webpPath: frame10webp,
    bgImage: 'img/preview/carousel/10.png'
  }
]
